export default function showThreejsJourney1() {
    const container = document.getElementById('changeManagementMessage')
    if (!container) return

    const messages = [...container.querySelectorAll('.js-message')]
    container.classList.remove('is-hover-yes', 'is-hover-none')
    container.classList.add('is-hover-yes', 'is-active')

    // Reset
    messages.forEach(msg => {
        msg.classList.remove('is-visible')
        msg.style.transform = 'translateY(120px)'
    })

    let step = 0
    const showStep = () => {
        if (step >= messages.length) return

        const current = messages[step]
        current.classList.add('is-visible')
 
        // Vertikale Staffelung
        let offset = 0
        for (let i = 0; i <= step; i++) {
            const el = messages[i]
            el.style.transform = `translateY(${-offset}px)`
            offset += el.offsetHeight - 45
        }

        step++
        if (step < messages.length) {
            setTimeout(showStep, 1800)
        }
    }
        // Automatisch wieder ausblenden
        setTimeout(() => {
            messages.forEach(msg => msg.classList.remove('is-visible'))
            container.classList.remove('is-active')
        }, 15000)

    showStep()
}
